import React from "react";
import { AdminLogin, SEO } from "../../../components";

const AdminLoginPage = () => {
  return (
    <>
      <SEO title="Login" />
      <AdminLogin />
    </>
  );
};

export default AdminLoginPage;
